export const defaultProductVariants = {
  initial: { scale: 0.98, transition: { type: "spring", stiffness: 100, damping: 10 } },
  animate: { scale: 1, transition: { type: "spring", stiffness: 100, damping: 10 } },
  exit: { scale: 0.96, transition: { type: "spring", stiffness: 100, damping: 10 } },
};